(function(){
  function setHeaderHeight(){
    var header=document.querySelector('.pckey-v66-header');
    if(!header) return;
    document.documentElement.style.setProperty('--pckey-header-h', Math.ceil(header.getBoundingClientRect().height)+'px');
  }
  window.addEventListener('load', setHeaderHeight, {passive:true});
  window.addEventListener('resize', setHeaderHeight, {passive:true});
  setHeaderHeight();

  document.addEventListener('keydown', function(e){
    if(e.key !== 'Escape') return;
    document.querySelectorAll('[data-dropdown] [aria-expanded="true"]').forEach(function(btn){btn.setAttribute('aria-expanded','false');});
    document.querySelectorAll('[data-dropdown].is-open').forEach(function(el){el.classList.remove('is-open');});
    var nav=document.querySelector('[data-mobile-nav]');
    var toggle=document.querySelector('[data-menu-toggle]');
    if(nav) nav.classList.remove('is-open');
    if(toggle) toggle.setAttribute('aria-expanded','false');
  });

  document.querySelectorAll('[data-mobile-nav] a').forEach(function(a){
    a.addEventListener('click', function(){
      var nav=document.querySelector('[data-mobile-nav]');
      var toggle=document.querySelector('[data-menu-toggle]');
      if(window.matchMedia('(max-width: 989px)').matches){
        if(nav) nav.classList.remove('is-open');
        if(toggle) toggle.setAttribute('aria-expanded','false');
      }
    });
  });
})();
